import { ComponentClass } from 'react';
import { createLazyComponent, LazyModule } from 'owa-bundling';
import {
    lazyfindBulkActionItemAction,
    lazySubscribeToBulkActionNotification,
} from 'owa-bulk-action-store';
import { runAfterInitialRender } from 'owa-delayed-initialization';
import { default as BulkActionScenarioType } from './types/BulkActionScenarioType';

const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "BulkActions" */ './lazyIndex')
);

export { BulkActionScenarioType };
export { ComponentClass };
export let BulkActionProgressBar = createLazyComponent(lazyModule, m => m.BulkActionProgressBar);

runAfterInitialRender(() => {
    lazyfindBulkActionItemAction.importAndExecute();
    lazySubscribeToBulkActionNotification.importAndExecute();
});
